export default __webpack_public_path__ + "static/images/5677a7b9.png";